<div oui-dialog-title>
  Demande de cessation d'activité
  <oui-button type="icon" oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
</div>

<oui-dialog-content class="dialog-content">
  @if (isLoading()) {
    <div class="loading-container">
      <oui-loading></oui-loading>
    </div>
  } @else {
    <span>Vous êtes sur le point de mettre fin à notre collaboration</span>

    <div class="inline-checkbox">
      <oui-checkbox
        label="Je ne souhaite pas faire de préavis"
        [control]="form.get('sansPreavis')"></oui-checkbox
      ><span class="caption primary">résiliation immédiate</span>
    </div>

    @if (displayPreavis()) {
      <span
        >En raison de votre ancienneté, votre résiliation prendra effet le
        {{ dateFinPreavis() }} après un préavis de {{ nbMoisPreavis() }} mois</span
      >
    }

    <span>Précisez le motif de la résiliation :</span>

    <oui-textarea label="Commentaire" [control]="form.get('commentaire')"></oui-textarea>
  }
</oui-dialog-content>

<oui-dialog-actions class="dialog-actions">
  <oui-button type="text" [disabled]="isLoading()" oui-dialog-close>Annuler</oui-button>
  <oui-button
    [type]="form.valid ? 'contained' : 'outlined'"
    [disabled]="isLoading()"
    (click)="sendDemandeResiliation()"
    >Valider</oui-button
  >
</oui-dialog-actions>
